<script>
  import { fly } from 'svelte/transition';

  export let text;
  export let linkto;
  export let embedurl;
  export let click;

  export let top;
  export let right;
  export let left;
  export let bottom;

  export let width;
  
  
  function openUrl(){
      let win = window.open(linkto, '_blank');
      win.focus();
  }

  function openEmbed(){

  }

  if(!click && linkto){ click = openUrl; }
  if(!click && embedurl){ click = openEmbed; }
  </script>
  
  <style>
      div.button {
          position: absolute;
          right: 72px;
          top: 20px;
          z-index: 999;
          cursor:pointer;

          background: rgba(239, 94, 73, 1);
          font-family: 'Source Sans Pro', sans-serif;
          font-weight: 700;
          font-size: 12px;
          line-height: 36px;
          color: #fff;
          padding: 3px 16px;
          text-align: center;
          text-transform: uppercase;
          border-radius: 5px;
          border: 2px solid rgba(239, 94, 73, 1);
      }

      div.button:hover {
        background:rgb(243 73 48);
        border: 2px solid rgb(1, 45, 92);
      }
  
      @media only screen and (max-width: 600px) {
      }
  </style>

  <div class="button" on:click={click} transition:fly={{y: -300, duration: 500 }}>{text}</div>
  